import Model from '@/lib/data/Model';

class Token extends Model {
    static idProperty = 'id';

    editing = false;

    success = false;

    translationEdit = null;

    fields = [
        'id',
        'token',
        'language_code',
        'translation',
        {
            name: 'hasTranslation',
            mapping: 'translation',
            defaultValue: false,
        },
    ];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'updateTranslation',
            url: '/translation/update',
        },
    ];
}

export default Token;
